import React from 'react';
import { IconProps } from '../types/types';

const HT: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 88 135.9" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path d="M57.8 41.8c0-19.5-9.4-36.3-16.6-41.8 0 0-.5-.3-.5.5-.6 37.7-19.7 48-30.3 61.7-24.3 31.8-1.7 66.6 21.3 73 12.9 3.6-3-6.4-5-27.4-2.4-25.5 31.1-44.9 31.1-66" fill="#282e5b"/><path d="M70.4 54.7c-.1-.1-.3-.1-.5 0l-.1.1c-.4 4.7-5.6 14.9-12.1 24.2-22.1 31.6-9.5 46.8-2.4 55 4.1 4.8 0 0 10.3-4.9.8-.4 20-10.6 22.1-33.7 2.1-22.5-12.2-36.6-17.3-40.7" fill="#059bdc"/></svg>
);

export default HT;
